import React, { useEffect } from "react";
import _ from "lodash";
import styles from "./deleteStream.module.scss";
import Slider from "../../../components/slider";
import Button from "../../../components/button";
import { StreamDescription } from "../types";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";
import { useStreamsAdoption } from "src/redux/actions/adoption/streams";
import Thumbnail from "src/components/thumbnail";
import { Media } from "src/types/media";

interface DeleteStreamProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  stream: StreamDescription;
  deleteStreamClick: (id: string) => void;
}

const DeleteStream: React.FC<DeleteStreamProps> = ({ open, setOpen, stream, deleteStreamClick }) => {

  const { trackStreamDeleteViewed } = useStreamsAdoption();

  const deleting = useSelector((state: any) => _.get(state, `stream.items.${stream?.id}.deletion.deleting`, false));
  const analytics = useSelector((state: any) => _.get(state, `stream.items[${stream?.id}].item.analytics`, null));
  const streamIcon = _.get(stream, "icon", "");
  const assetsCount = _.get(analytics, "item.assetCount", 0);

  useEffect(() => {
    if(open){
      trackStreamDeleteViewed();
    }
  }, [open])

  return (
    <Slider.Dialog
      className={styles.deleteSlider}
      width="300"
      show={open}
      onClose={() => setOpen(false)}
    >
      <Slider.Header
        title="deleting..."
        message={_.get(stream, "name")}
      ></Slider.Header>
      <Slider.Body>
        <div className={styles.details}>
          <span>
            You’re about to delete the entire stream with {assetsCount} assets.
            Can we lock in your decision, or should we call in the backup
          </span>

          {streamIcon ? (
            <Thumbnail
              key={_.get(stream, "id")}
              className={styles.image}
              media={streamIcon as Media}
            />
          ) : (
            <img
              src="/images/assets/default_asset.jpg"
              alt={_.get(stream, "name", "Default Stream")}
              className={styles.image}
            />
          )}
        </div>
      </Slider.Body>
      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={deleting ? "Deleting..." : "Confirm"}
          variant="primary"
          disabled={deleting}
          onClick={() => deleteStreamClick(_.get(stream, "id"))}
        />
        <Button
          text="Cancel"
          variant="secondary"
          disabled={deleting}
          onClick={() => setOpen(false)}
        />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteStream;
